import { webApiUrl } from "./constants";
import { AuditRequest } from "./interfaces/auditRequest";
import MonthlyLicenseAudit from "./interfaces/monthlyLicenseAudit";

export const getAudit = async (
  timeFrame: AuditRequest,
  token: string
): Promise<MonthlyLicenseAudit | null> => {
  const request = new Request(`${webApiUrl}/audit`, {
    method: "post",
    body: JSON.stringify(timeFrame),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) {
    const audit = await response.json();

    return audit;
  } else {
    return null;
  }
};
